import {createContext, useContext} from 'react';

// Context for CallsTable compound components
export interface CallsTableSlotsContextValue {
  setFilterPanelExtensionSlot: (slot: React.ReactNode) => void;
  filterPanelExtensionSlot: React.ReactNode;
}

export const CallsTableSlotsContext =
  createContext<CallsTableSlotsContextValue | null>(null);

export const useCallsTableSlotsContext = () => {
  const ctx = useContext(CallsTableSlotsContext);
  if (!ctx) {
    throw new Error('CallsTable sub-components must be used within CallsTable');
  }
  return ctx;
};
